import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, ListItemIcon, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { DeleteWareHouseMutation } from "../../lib/graphQL/graphMutation";
import { AllWareHouseDetailsQuery } from "../../lib/graphQL/graphQuery";
import { useLoading } from "../../context/LodingContext";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function WareHouseListTable() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [wareHouseData, setWareHouseData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
 
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const { circleLoading, setCirleLoading } = useLoading();

  const wareHouseListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "WareHouse ID",
        field: "id",
        name: "WareHouse ID",
        flex: 1.2,
        // width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "WareHouse Name",
        field: "wareHouseName",
        name: "WareHouse Name",
        flex: 1.2,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Category",
        field: "categoryName",
        name: "Category",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "WareHouse Capacity",
        field: "wareHouseCapacity",
        name: "WareHouse Capacity",
        flex: 1.5,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "UOM Capacity",
        field: "uomCapacity",
        name: "UOM Capacity",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Supervisor",
        field: "supervisorName",
        name: "Supervisor",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: wareHouseData.reverse().map(
      (item, index) => (
        {
          sno: index + 1,
          id: item.id,
          wareHouseName: item.warehouseName,
          categoryName: item.category,
          wareHouseCapacity: item.warehouseCapacity,
          uomCapacity: item.capacityUom,
          supervisorName: item.supervisorName,
          createdBy: item.user.username,
        }
      )
    ),
  };

  const fetchWareHouseData = () => {
    setIsLoading(true);
    request(BASEURL, AllWareHouseDetailsQuery, { id: currentUser?.id })
      .then((res) => {
        setWareHouseData(res.allWarehouse);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchWareHouseData();
    setStatus(false);
  }, [id, status]);

  const handleDeleteWareHouse = (row) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this row?"
    );
    if (confirmed) {
      request(BASEURL, DeleteWareHouseMutation, { id: row.id }).then((res) => {
        setStatus(true);
      });
    }
  };

  const handleNewWareHouse = () => {
    navigate("/wareHouse/add-wareHouse");
  };

  const onWareHouseListClick = (e) => {
    const editWareHouseData = wareHouseData.find((item) => item?.id === e?.id);
    if (e?.id) {
      navigate(`/wareHouse/add-wareHouse?${e?.id}`);
    }
  };

  const onDelete=(id)=>
    {
      console.log("id-d",id)
    }
    
    const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
    const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={wareHouseListTable.columns}
      rowsData={wareHouseListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Warehouse List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onWareHouseListClick}
      // onDelete={onDelete}
      onView={onWareHouseListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewWareHouse()}
      />
      </DashboardLayout>
    // <Card>
//   <CardHeader
//     // title={
//     //   <Stack
//     //     direction="row"
//     //     justifyContent="space-between"
//     //     alignItems="center"
//     //     spacing={2}
//     //   >
//     //     {/* <Stack direction="column" spacing={0}>
//     //       <MaterialTypography variant="h5" fontWeight="medium">
//     //         WareHouse List
//     //       </MaterialTypography>
//     //     </Stack> */}

//     //     {/* <MaterialButton
//     //       variant="gradient"
//     //       color="dark"
//     //       size="small"
//     //       startIcon={<AddIcon />}
//     //       onClick={() => handleNewWareHouse()}
//     //     >
//     //       WareHouse
//     //     </MaterialButton> */}
//     //   </Stack>
//     // }
//   />
//   {/* {!isLoading && <MaterialDataGrid
//     // customHeight={550}
//     rows={wareHouseListTable.rows}
//     columns={wareHouseListTable.columns}
//     // checkboxSelection={false}
//     isSelectable={false}
//     onRowClick={onWareHouseListClick}
//     loading={pageState.loading}
//     localeText={{
//       noRowsLabel: (
//         <Stack
//           direction="column"
//           alignItems="center"
//           justifyContent="center"
//           spacing={1}
//         >
//           <MaterialTypography
//             variant="body2"
//             fontWeight="medium"
//             color="text"
//           >
//             No WareHouse found
//           </MaterialTypography>
//           <MaterialTypography variant="caption" color="text">
//             You have not yet add any WareHouse details. Click on the "Add
//             WareHouse" button to start adding WareHouse details.
//           </MaterialTypography>
//         </Stack>
//       ),
//     }}
//   />} */}
//   {/* {isLoading && <PageLoading />} */}
// </Card>

    
  );
}
